import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Login from "./Components/Login/Login";
import PublicRoute from "./Auth/PublicRoute";
import PrivateRoute from "./Auth/PrivateRoute";
import Home from "./Components/Home/Home";
import Driver from "./Components/Configurations/Driver/Driver";
import Linea from "./Components/Configurations/Linea/Linea";
import CreateLinea from "./Components/Configurations/Linea/Create";
import CreateDriver from "./Components/Configurations/Driver/Create";
import { BrowserRouter, Link, Route, Routes, useNavigate } from 'react-router-dom';
import { LoggedContext } from "./Auth/AuthContext";
import { isLogged } from "./Utils/AuthUtils";
import Configurations from "./Components/Configurations/Configurations";
import { GetBasePath, SetPostMessageListener } from "./Utils/BaseUtils";
import './css/style.css';
import Edit from "./Components/Configurations/Linea/Edit";
import Box from "./Components/BoxActions/BoxPage";
import User from "./Components/User/UserPage";

function App() {
    const [auth, setAuth] = useState(isLogged());
    const basePath = GetBasePath();

    useEffect(() => {
        SetPostMessageListener(setAuth);
    }, []);

    return (
        <BrowserRouter basename={basePath}>
            <LoggedContext.Provider value={{ auth, setAuth }}>
                <Routes>
                    <Route element={<PublicRoute />}>
                        <Route path="/login" element={<Login />} />
                    </Route>
                    <Route element={<PrivateRoute />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/configurations" element={<Configurations />}>
                            <Route path="/configurations/linea" element={<Linea />} />
                            <Route path="/configurations/driver" element={<Driver />} />
                            <Route path="/configurations/view" element={<Box />} />
                            <Route path="/configurations/user" element={<User />} />
                        </Route>
                        <Route path="/configurations/linea/create" element={<CreateLinea />} />
                        <Route path="/configurations/linea/edit/:id" element={<Edit />} />
                        <Route path="/configurations/driver/create" element={<CreateDriver />} />
                    </Route>
                </Routes>
            </LoggedContext.Provider>
        </BrowserRouter>
    );
}

export default App;
